// Project ledger data as the backend (ProjectController / Project, ProjectLedger, ProjectNote) uses it:
//   projects      -> response.projects        { id, project_name, client_name*, client_mobile, client_address, description, status, balance }
//   ledger rows   -> response.projectLedgers  { id, type: CREDIT|DEBIT, amount, transaction_date "dd-MM-yyyy HH:mm:ss", description, balance }
//   notes         -> response.projectNotes    { id, title*, content*, updated_date }   (* required)
//   summaries     -> { totalCredit, totalDebit, totalBalance }

const pad = (n) => String(n).padStart(2, "0");

/** Local YYYY-MM-DD for <input type="date">. */
export const todayDate = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** "dd-MM-yyyy HH:mm:ss" (the API format) -> YYYY-MM-DD, or today when missing/unparseable. */
export const ledgerDateInput = (apiDate) => {
  const m = /^(\d{2})-(\d{2})-(\d{4})/.exec(String(apiDate || ""));
  return m ? `${m[3]}-${m[2]}-${m[1]}` : todayDate();
};

/**
 * YYYY-MM-DD -> "dd-MM-yyyy HH:mm:ss" for the API. An edited entry that keeps its date keeps its time;
 * otherwise the current time is used.
 */
export const toLedgerApiDate = (dateValue, originalApiDate) => {
  const [y, mo, d] = String(dateValue).split("-");
  const original = String(originalApiDate || "");
  if (original && ledgerDateInput(original) === dateValue) return original.slice(0, 19);
  const now = new Date();
  return `${d}-${mo}-${y} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

/** Readable date for lists; accepts the API's "dd-MM-yyyy ..." or an ISO date. */
export const formatLedgerDate = (apiDate) => {
  if (!apiDate) return "";
  const m = /^(\d{2})-(\d{2})-(\d{4})/.exec(String(apiDate));
  const d = m ? new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])) : new Date(apiDate);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const isCreditEntry = (entry) => String(entry?.type || "").toUpperCase() === "CREDIT";

export const inr = (value) => `₹${Number(value || 0).toLocaleString("en-IN")}`;

// The API answers 200 with statusType FAILURE for business errors
export const assertSuccess = (res, fallback) => {
  if (res?.statusType && res.statusType !== "SUCCESS") throw new Error(res.text || fallback);
  return res;
};

export const errorText = (err, fallback) =>
  err?.response?.data?.text || err?.response?.data?.message || err?.message || fallback;
